export const WITHDRAWN_USER_CODE = "withdrawn_user";

const WITHDRAWN_USER_MESSAGE = "탈퇴한 계정은 재가입할 수 없습니다";

export const isWithdrawnUserHttpError = (error) =>
  error?.response?.status === 403 &&
  (error?.response?.data?.code === WITHDRAWN_USER_CODE ||
    error?.response?.data?.error === WITHDRAWN_USER_MESSAGE);

export const isWithdrawnUserCallback = (params) =>
  params.get("status") === "error" &&
  params.get("code") === WITHDRAWN_USER_CODE;
